import React from 'react';

function HeartSvg() {
  return (
    <svg
      width="72"
      height="51"
      viewBox="0 0 83 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M81.7122 14.0554C72.8683 -9.43623 44.1255 1.06593 41.5 12.8118C37.9072 0.374993 9.85534 -8.88349 1.28779 14.0554C-8.24707 39.6199 38.1835 62.5588 41.5 66.2899C44.8165 63.2498 91.2471 39.2053 81.7122 14.0554Z"
        fill="#FF5A79"
      />
    </svg>
  );
}

export default HeartSvg;
